import SettingsIcon from '@mui/icons-material/Settings';
export { SettingsList } from './list';
export { SettingsShow } from './show';
export const SettingIcon = SettingsIcon;
